
import React, { useState } from "react";

import { db, storage } from "../../firebase";
import logo from "../images/logo_mmcpnadia.png";

import {
  collection,
  serverTimestamp,
  doc,
  runTransaction,
} from "firebase/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";


function StudentForm() {

  // Initial Form Data
  const initialFormData = {
    applicantName: "",
    fatherName: "",
    motherName: "",
    guardianName: "",
    dob: "",
    contactNo: "",
    aadharNo: "",
    gender: "",
    category: "",
    email: "",
    religion: "",
    hsBoard: "",
    address: "",
    hsSubject: "",
    totalMarks: "",
    marksObtained: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const [photo, setPhoto] = useState(null);
  const [signature, setSignature] = useState(null);
  const [aadharCard, setAadharCard] = useState(null);
  const [hsMarksheet, setHsMarksheet] = useState(null);

  const [loading, setLoading] = useState(false);

  // File Size Limit
  const MAX_SIZE = {
    photo: 2 * 1024 * 1024,
    signature: 1 * 1024 * 1024,
    aadhar: 2 * 1024 * 1024,
    marksheet: 3 * 1024 * 1024,
  };


  // Handle Input Change
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };


  // Validate File
  const validateFile = (file, maxSize, name) => {

    if (!file) {
      alert(`Please upload ${name}.`);
      return false;
    }

    if (file.size > maxSize) {

      alert(
        `${name} size must be within ${
          maxSize / (1024 * 1024)
        } MB.`
      );

      return false;
    }

    return true;
  };


  // Upload File to Firebase Storage
  const uploadFile = async (file, folder) => {

    const fileRef = ref(
      storage,
      `${folder}/${Date.now()}_${file.name}`
    );

    await uploadBytes(fileRef, file);

    return await getDownloadURL(fileRef);
  };


  // Form Submit
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (loading) return;


    // Required Documents
    if (!photo || !signature || !aadharCard || !hsMarksheet) {

      alert("Please upload all required documents.");

      return;
    }


    // File Size Validation
    if (!validateFile(photo, MAX_SIZE.photo, "Photograph")) return;

    if (!validateFile(signature, MAX_SIZE.signature, "Signature")) return;

    if (!validateFile(aadharCard, MAX_SIZE.aadhar, "Aadhaar Card")) return;

    if (!validateFile(hsMarksheet, MAX_SIZE.marksheet, "HS Marksheet")) return;


    // Marks Validation
    if (
      Number(formData.marksObtained) >
      Number(formData.totalMarks)
    ) {

      alert("Marks Obtained cannot exceed Total Marks.");

      return;
    }


    try {

      setLoading(true);


      // Upload Documents
      const photoURL = await uploadFile(
        photo,
        "teacher_application/photo"
      );

      const signatureURL = await uploadFile(
        signature,
        "teacher_application/signature"
      );

      const aadharURL = await uploadFile(
        aadharCard,
        "teacher_application/aadhar"
      );

      const hsMarksheetURL = await uploadFile(
        hsMarksheet,
        "teacher_application/hs_marksheet"
      );


      // Generate Application ID
      const year = new Date().getFullYear();

      const counterRef = doc(
        db,
        "application_counters",
        `student_admission_${year}`
      );


      // Create Application Document Reference
      const applicationRef = doc(
        collection(db, "teacher_application_data")
      );


      // Firestore Transaction
      const applicationId = await runTransaction(
        db,
        async (transaction) => {

          const counterSnap = await transaction.get(counterRef);

          const lastSerial = counterSnap.exists()
            ? counterSnap.data().lastSerial || 0
            : 0;

          const nextSerial = lastSerial + 1;


          // Application ID Format
          const newApplicationId =
            `MMCPDPHARM${year}${String(nextSerial).padStart(4, "0")}`;


          // Update Counter
          transaction.set(counterRef, {

            lastSerial: nextSerial,
            year: year,
            updatedAt: serverTimestamp(),

          });


          // Save Application Data
          transaction.set(applicationRef, {

            ...formData,

            applicationId: newApplicationId,

            photoURL,
            signatureURL,
            aadharURL,
            hsMarksheetURL,

            applicationStatus: "SUBMITTED",

            createdAt: serverTimestamp(),

          });


          return newApplicationId;

        }
      );


      // Success Message
      alert(
        `Application Submitted Successfully!\n\nYour Application ID: ${applicationId}`
      );


      // Reset Form
      setFormData(initialFormData);

      setPhoto(null);
      setSignature(null);
      setAadharCard(null);
      setHsMarksheet(null);

      e.target.reset();


    } catch (error) {

      console.error("Submission Error:", error);

      alert(
        "Application Submission Failed! Please try again."
      );

    } finally {

      setLoading(false);

    }

  };


  return (

    <div className="album py-3">

      <div className="container">

        <div className="card shadow p-2 p-md-3">

          {/* Logo & Heading */}

          <h2 className="text-center text-primary mb-3">

            <center>

              <img
                src={logo}
                className="card-img-top custom-logo"
                alt="mmcpnadia_logo"
              />

            </center>

            <b style={{ color: "#7E1717" }}>
              Student Admission Form
            </b>

          </h2>


          <form onSubmit={handleSubmit}>

            {/* Personal Details */}

            <h5
              style={{ color: "#199FA0" }}
              className="border-bottom pb-2"
            >
              Personal Details
            </h5>


            <input
              className="form-control mt-3"
              name="applicantName"
              placeholder="Name of Applicant"
              value={formData.applicantName}
              onChange={handleChange}
              required
            />


            <input
              className="form-control mt-3"
              name="fatherName"
              placeholder="Father's Name"
              value={formData.fatherName}
              onChange={handleChange}
              required
            />


            <input
              className="form-control mt-3"
              name="motherName"
              placeholder="Mother's Name"
              value={formData.motherName}
              onChange={handleChange}
              required
            />


            <input
              className="form-control mt-3"
              name="guardianName"
              placeholder="Guardian's Name"
              value={formData.guardianName}
              onChange={handleChange}
              required
            />


            <label className="mt-3">
              Date of Birth
            </label>

            <input
              type="date"
              className="form-control"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />


            <input
              type="tel"
              className="form-control mt-3"
              name="contactNo"
              placeholder="Contact Number"
              pattern="[0-9]{10}"
              maxLength="10"
              value={formData.contactNo}
              onChange={handleChange}
              required
            />


            <input
              type="text"
              className="form-control mt-3"
              name="aadharNo"
              placeholder="Aadhaar Number"
              pattern="[0-9]{12}"
              maxLength="12"
              value={formData.aadharNo}
              onChange={handleChange}
              required
            />


            {/* Gender */}

            <select
              className="form-control mt-3"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >

              <option value="">
                Select Gender
              </option>

              <option value="Male">Male</option>

              <option value="Female">Female</option>

              <option value="Other">Other</option>

            </select>


            {/* Category */}

            <select
              className="form-control mt-3"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >

              <option value="">
                Select Category
              </option>

              <option value="GEN">GEN</option>

              <option value="SC">SC</option>

              <option value="ST">ST</option>

              <option value="OBC-A">OBC-A</option>

              <option value="OBC-B">OBC-B</option>

              <option value="PH">PH</option>

            </select>


            <input
              type="email"
              className="form-control mt-3"
              name="email"
              placeholder="E-mail Address"
              value={formData.email}
              onChange={handleChange}
              required
            />


            <input
              className="form-control mt-3"
              name="religion"
              placeholder="Religion"
              value={formData.religion}
              onChange={handleChange}
              required
            />


            {/* HS Details */}

            <h5
              style={{ color: "#199FA0" }}
              className="border-bottom pb-2 mt-4"
            >
              Higher Secondary (HS) Details
            </h5>


            <input
              className="form-control mt-3"
              name="hsBoard"
              placeholder="HS Board Name"
              value={formData.hsBoard}
              onChange={handleChange}
              required
            />


            <input
              className="form-control mt-3"
              name="hsSubject"
              placeholder="HS Subject"
              value={formData.hsSubject}
              onChange={handleChange}
              required
            />


            <input
              type="number"
              className="form-control mt-3"
              name="totalMarks"
              placeholder="Total Marks (HS)"
              min="1"
              value={formData.totalMarks}
              onChange={handleChange}
              required
            />


            <input
              type="number"
              className="form-control mt-3"
              name="marksObtained"
              placeholder="Marks Obtained"
              min="0"
              value={formData.marksObtained}
              onChange={handleChange}
              required
            />


            {/* Address Details */}

            <h5
              style={{ color: "#199FA0" }}
              className="border-bottom pb-2 mt-4"
            >
              Address Details
            </h5>


            <textarea
              className="form-control mt-3"
              name="address"
              rows="3"
              placeholder="Full Address"
              value={formData.address}
              onChange={handleChange}
              required
            />


            {/* Document Upload */}

            <h5
              style={{ color: "#037a7e" }}
              className="border-bottom pb-2 mt-4"
            >
              Upload Documents
            </h5>


            <label className="mt-3">
              Photograph (Maximum 2 MB)
            </label>

            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={(e) => setPhoto(e.target.files[0])}
              required
            />


            <label className="mt-3">
              Signature (Maximum 1 MB)
            </label>

            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={(e) => setSignature(e.target.files[0])}
              required
            />


            <label className="mt-3">
              Aadhaar Card (Maximum 2 MB)
            </label>

            <input
              type="file"
              className="form-control"
              accept="image/*,.pdf"
              onChange={(e) => setAadharCard(e.target.files[0])}
              required
            />


            <label className="mt-3">
              HS Marksheet (Maximum 3 MB)
            </label>

            <input
              type="file"
              className="form-control"
              accept="image/*,.pdf"
              onChange={(e) => setHsMarksheet(e.target.files[0])}
              required
            />


            {/* Submit Button */}

            <button
              type="submit"
              className="btn btn-success mt-4 w-100"
              disabled={loading}
            >

              {loading
                ? "Submitting Application..."
                : "SUBMIT APPLICATION"}

            </button>

          </form>

        </div>

      </div>

    </div>

  );

}

export default StudentForm;
